import React from 'react'
import { useGoogleLogin } from '@react-oauth/google'

import { Button, GoogleIcon } from '../../lib/components'
import { GLoginProps } from '../../lib/types'

export const GLogin = ({
  onSuccess,
  onFailure,
  buttonText = 'Continue with google',
}: GLoginProps) => {
  const login = useGoogleLogin({
    onSuccess,
    onError: onFailure,
    scope: 'openid email profile',
  })

  return (
    <Button
      classes={['mb-16']}
      text={buttonText}
      variant='basic-btn'
      handleClick={() => login()}
      IconComponent={<GoogleIcon />}
      iconVariant='left'
    />
  )
}
